module.exports = __webpack_public_path__ + "static/media/madhucon5.449b564a.png";